export default "__VITE_ASSET__Cum9xJjQ__"